// extracted by mini-css-extract-plugin
export default {"container":"GeneralAssets_container__ThXWw","navPageHeader":"GeneralAssets_navPageHeader__4QSBx"};